angular.module('app').config(documentTypesRouting);

function documentTypesRouting($routeProvider) {
  $routeProvider.when('/document_types', {
    pageTitle: 'DOCUMENT_TYPES',
    template: '<document-types-page></document-types-page>',
    breadcrumb: {
      label: 'COMPANY_SETTINGS',
      parent: 'ng/company_settings',
    },
    accessPermission: 'index_documenttype_accountadmin',
    menu: 'settings',
    authReq: true,
  });
}

documentTypesRouting.$inject = ['$routeProvider'];
